import { render, staticRenderFns } from "./FonterraReportPage.vue?vue&type=template&id=6a535e5e&"
import script from "./FonterraReportPage.vue?vue&type=script&lang=js&"
export * from "./FonterraReportPage.vue?vue&type=script&lang=js&"
import style0 from "./FonterraReportPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports